
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <b-card class="card-collapse border-raduis-xl border-0 box-shadow-sm my-4">
      <div class="title">
        <h4 class="mb-0 pr-5" :class="{'text-primary': !noTitlePrimary}" >
          <slot name="title"></slot>
        </h4>
        <div v-if="!noButton" class="btn-collapse" v-b-toggle="id">
          <b-icon icon="chevron-up" class="fsize-2"></b-icon>
        </div>
      </div>
      <b-collapse :id="id" :visible="visible">
        <slot name="body"></slot>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'CollapseCard',
  props: ['id','visible','noButton','noTitlePrimary'],
};
</script>
